import React from 'react'
import { useIntl } from 'react-intl'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { useRoles } from '../../../../../hooks/userRoleContext'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const { roles } = useRoles()

  // Verifica se l'utente ha il ruolo 'admin'
  const isAdmin = roles ? roles.includes('Admin') : false
  const isPartner = roles ? roles.includes('Socio') : false
  const isMarketing = roles ? roles.includes('Dipendente - Marketing') : false
  const isAccounting = roles ? roles.includes('Dipendente - Amministrazione') : false
  const isDevelopment = roles ? roles.includes('Dipendente - Sviluppo') : false
  const isDelivery = roles ? roles.includes('Dipendente - Delivery') : false
  const isTraining = roles ? roles.includes('Dipendente - Formazione') : false
  const isCustomerService = roles ? roles.includes('Dipendente - Assistenza') : false

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/general/gen001.svg'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        fontIcon='bi-app-indicator'
      />

      {/* Ordini noleggio/vendita */}
      {(isAccounting || isAdmin || isPartner || isCustomerService || isMarketing || isTraining || isDelivery) && (
        <SidebarMenuItemWithSub
          to='#'
          title='Ordini'
          icon='/media/icons/duotune/abstract/abs034.svg'
          fontIcon='bi-archive'
        >
          <SidebarMenuItem to='/inserisci-ordine' title='Inserisci' hasBullet={true} />
          <SidebarMenuItem to='/stato-ordini' title='Stato' hasBullet={true} />
        </SidebarMenuItemWithSub>
      )}

      {/* Contabilità 
      {(isAccounting || isAdmin || isPartner || isCustomerService) && (
        <>
          <SidebarMenuItemWithSub
            to='#'
            title='Contabilità'
            icon='/media/icons/duotune/finance/fin007.svg'
            fontIcon='bi-archive'
          >
            <SidebarMenuItem to='/panoramica' title='Panoramica' hasBullet={true} />
          </SidebarMenuItemWithSub>
        </>
      )}*/}

      {/* Visori */}
      {(isAccounting || isAdmin || isPartner || isCustomerService || isTraining || isDelivery || isMarketing) && (
        <SidebarMenuItemWithSub
          to='#'
          title='Visori'
          icon='/media/icons/duotune/technology/teh006.svg'
          fontIcon='bi-archive'
        >
          <SidebarMenuItem to='/inserisci-visore' title='Inserisci' hasBullet={true} />
          <SidebarMenuItem to='/libro-mastro' title='Libro mastro' hasBullet={true} />
        </SidebarMenuItemWithSub>
      )}

      {/* Simulazioni */}
      {(isAdmin || isPartner || isCustomerService || isTraining || isDelivery || isMarketing || isDevelopment) && (
        <SidebarMenuItemWithSub
          to='#'
          title='Simulazioni'
          icon='/media/icons/duotune/abstract/abs030.svg'
          fontIcon='bi-archive'
        >
          <SidebarMenuItem to='/inserisci-simulazione' title='Inserisci' hasBullet={true} />
          <SidebarMenuItem to='/stato-simulazioni' title='Stato' hasBullet={true} />
        </SidebarMenuItemWithSub>
      )}

      {/* Altri inserimenti */}
      {(isAdmin || isPartner) && (
        <SidebarMenuItemWithSub
          to='#'
          title='Altri inserimenti'
          icon='/media/icons/duotune/general/gen055.svg'
          fontIcon='bi-archive'
        >
          <SidebarMenuItem to='/inserisci-piano-abbonamento' title='Inserisci piano abbonamento' hasBullet={true} />
          <SidebarMenuItem to='/inserisci-intermediario' title='Inserisci intermediario' hasBullet={true} />
        </SidebarMenuItemWithSub>
      )}

      {/*Statistiche*/}
      {(isAccounting || isAdmin || isPartner || isCustomerService || isTraining || isDelivery || isMarketing || isDevelopment) && (
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Statistiche</span>
        </div>
      </div>
      )}

      {(isAccounting || isAdmin || isPartner || isCustomerService || isTraining || isDelivery || isMarketing || isDevelopment) && (
        <>
          <SidebarMenuItemWithSub
            to='#'
            title='Ordini'
            fontIcon='bi-archive'
            icon='/media/icons/duotune/graphs/gra001.svg'
          >
            <SidebarMenuItem to='/statistiche-ordini-in-scadenza' title='Contratti in scadenza' hasBullet={true} />
            <SidebarMenuItem to='/statistiche-ordini-entrati-nonrinnovati' title='Contratti entrati/non rinnovati' hasBullet={true} />
          </SidebarMenuItemWithSub>
        </>
      )}

      {/*Impostazioni*/}
      {(isAdmin) && (
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Impostazioni</span>
        </div>
      </div>
      )}

      {(isAdmin) && (
        <>
          <SidebarMenuItemWithSub
            to='#'
            title='Console admin'
            fontIcon='bi-archive'
            icon='/media/icons/duotune/general/gen051.svg'
          >
            <SidebarMenuItem to='/gestione-utenti' title='Gestione utenti' hasBullet={true} />
          </SidebarMenuItemWithSub>
        </>
      )}
    </>
  )
}

export { SidebarMenuMain }
